// FormInput.tsx
import React from 'react'
import { Form, Input, Upload, Button } from 'antd'
import { UploadOutlined } from '@ant-design/icons'

interface FormInputProps {
  name: string
  label: string
  type: 'text' | 'textarea' | 'upload'
  rules: any[]
  uploadProps?: any // For upload component configurations
  value?: string // Optional for text and textarea inputs
  onChange?: (value: string) => void // Optional for text and textarea inputs
}

const FormInput: React.FC<FormInputProps> = ({
  name,
  label,
  type,
  rules,
  uploadProps,
  value,
  onChange,
}) => {
  let inputElement = null

  switch (type) {
    case 'text':
      inputElement = (
        <Input value={value} onChange={(e) => onChange?.(e.target.value)} />
      )
      break
    case 'textarea':
      inputElement = (
        <Input.TextArea
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
        />
      )
      break
    case 'upload':
      inputElement = (
        <Upload {...uploadProps}>
          <Button icon={<UploadOutlined />}>Click to upload</Button>
        </Upload>
      )
      break
    default:
      inputElement = <Input /> // Fallback default, not typically reached
  }

  return (
    <Form.Item name={name} label={label} rules={rules}>
      {inputElement}
    </Form.Item>
  )
}

export default FormInput
